// WIW soft icons: 24-unit optical grid, rounded contours, 1.8-unit strokes.
// Shared drawings adapted from the user-approved POTS A study
// (POTS/circles/client/src/shared/icon-shapes.js); WIW additions follow the same grid.
const path = (d, extra = {}) => ['path', { d, ...extra }];
const circle = (cx, cy, r, extra = {}) => ['circle', { cx, cy, r, ...extra }];
const rect = (x, y, width, height, rx = 3) => ['rect', { x, y, width, height, rx }];
const check = 'M7.5 12.3L10.6 15.4Q10.9 15.7 11.2 15.3L16.5 9';
const confirmation = path('M4.5 12.2L9.5 17.2Q9.9 17.6 10.3 17.1L19.5 6.8');
const cross = 'M8.6 8.6L15.4 15.4M15.4 8.6L8.6 15.4';
const badge = circle(12, 12, 9, { part: 'badge' });
// Share the speaker outline so toggling sound does not shift its silhouette.
const speaker = path('M7.5 8.5L11.1 5.3Q12 4.5 12 5.7V18.3Q12 19.5 11.1 18.7L7.5 15.5H4.5Q3 15.5 3 14V10Q3 8.5 4.5 8.5Z');
const bellBody = path('M6.8 10.2C6.8 2.5 17.2 2.5 17.2 10.2V14.3Q17.2 16.2 19.1 17.8H4.9Q6.8 16.2 6.8 14.3Z');
const bellDetails = path('M12 2.3V4.4M9.8 20.2Q12 22.5 14.2 20.2');
const account = [circle(12, 6.8, 3.7), path('M3.8 20.5V18.5C3.8 14.8 6.9 12.4 12 12.4S20.2 14.8 20.2 18.5V20.5')];

export const ICON_SHAPES = {
  brush: [path('M10.3 12.8L17.8 3.7Q19.1 2.2 20.5 3.5Q21.8 4.8 20.3 6.2L12.8 15.3ZM12 10.8L14.8 13.3'), path('M10.3 13.1C7.6 12.6 6.5 14.7 6.3 16.6Q6 19.2 3.1 19.8Q7.8 22 10.7 19.4Q13.5 16.9 11.8 14.5')],
  paperclip: [path('M8 12.5L14.7 5.8Q17.1 3.4 19.5 5.8Q21.9 8.2 19.5 10.6L10.6 19.5Q7 23.1 3.4 19.5Q-.2 15.9 3.4 12.3L12.3 3.4M6.8 15.9L15.7 7')],
  pen: [path('M4 16L15.9 4.1Q17.3 2.7 18.7 4.1L19.9 5.3Q21.3 6.7 19.9 8.1L8 20L3 21ZM14 6L18 10M4 16L8 20')],
  marker: [path('M9 13L16 3L22 7L15 17ZM9 13L6 14L5 19L10 20L12 17M3 21H12M14 6L20 10')],
  eraser: [path('M3.5 13.5L13 4Q14 3 15 4L21 10Q22 11 21 12L12 21H9L3.5 15.5Q2.5 14.5 3.5 13.5ZM8 9L17 18M12 21H21')],
  crop: [path('M7 3V15Q7 17 9 17H21M3 7H15Q17 7 17 9V21')],
  fullscreen: [path('M8 3H3V8M16 3H21V8M21 16V21H16M8 21H3V16')],
  fullscreenExit: [path('M3 8H8V3M21 8H16V3M16 21V16H21M8 21V16H3')],
  microphone: [rect(8.5, 2.5, 7, 12, 3.5), path('M5.5 10.5V11.5A6.5 6.5 0 0 0 18.5 11.5V10.5M12 18V21.5M8.5 21.5H15.5')],
  microphoneOff: [path('M3 3L21 21M8.5 8.5V11A3.5 3.5 0 0 0 14 13.9M8.8 4.6C9.8 1.3 15.5 2 15.5 6V10M5.5 10.5V11.5A6.5 6.5 0 0 0 15.9 16.7M18.2 13.5Q18.5 12.5 18.5 11.5V10.5M12 18V21.5M8.5 21.5H15.5')],
  volume: [speaker, path('M15.5 8.5C18.2 10.2 18.2 13.8 15.5 15.5M18.5 5.5C23.2 8.6 23.2 15.4 18.5 18.5')],
  volumeOff: [speaker, path('M16 9L21 15M21 9L16 15')],
  camera: [path('M8 5L9.3 3.5H14.7L16 5H19Q21 5 21 7V18Q21 20 19 20H5Q3 20 3 18V7Q3 5 5 5Z'), circle(12, 12.5, 4)],
  videoRecord: [circle(12, 12, 9), ['circle', { cx: 12, cy: 12, r: 4, fill: 'currentColor', stroke: 'none' }]],
  cameraSwitch: [path('M8 5L9.3 3.5H14.7L16 5H19Q21 5 21 7V18Q21 20 19 20H5Q3 20 3 18V7Q3 5 5 5Z'), path('M8 11Q9 8.5 12 8.5Q15 8.5 16 11M13.8 11H16V8.8M16 14Q15 16.5 12 16.5Q9 16.5 8 14M10.2 14H8V16.2')],
  play: [path('M8 4.5L19 11.1Q20.5 12 19 12.9L8 19.5Q6.5 20.4 6.5 18.6V5.4Q6.5 3.6 8 4.5Z')],
  pause: [rect(5.5, 4, 4, 16, 1.3), rect(14.5, 4, 4, 16, 1.3)],
  record: [circle(12, 12, 6.5, { fill: 'currentColor' })],
  stop: [['rect', { x: 5.5, y: 5.5, width: 13, height: 13, rx: 1.5, fill: 'currentColor' }]],
  heart: [path('M12 20.5C9.4 18.6 3 14.3 3 8.9C3 3.7 9.1 2.2 12 6.2C14.9 2.2 21 3.7 21 8.9C21 14.3 14.6 18.6 12 20.5Z')],
  plus: [path('M12 5V19M5 12H19')],
  plusCircle: [badge, path('M7.7 12H16.3M12 7.7V16.3', { part: 'mark' })],
  event: [path('M7 3H17Q20 3 20 6V18Q20 21 17 21H7Q4 21 4 18V6Q4 3 7 3ZM8 7H16M8 11H16M8 15H13')],
  newsAdd: [path('M13 21H6Q3 21 3 18V6Q3 3 6 3H16Q19 3 19 6V11M7 7H15M7 11H12M7 15H10M18 14V22M14 18H22')],
  repost: [
    path('M4 10V8Q4 5 7 5H20M17 2L20 5L17 8'),
    path('M20 14V16Q20 19 17 19H4M7 16L4 19L7 22'),
  ],
  chat: [path('M7 4H17Q21 4 21 8V13Q21 17 17 17H10L5 20V16.5Q3 15.7 3 13V8Q3 4 7 4Z')],
  commentEdit: [
    path('M7 4H17Q21 4 21 8V13Q21 17 17 17H10L5 20V16.5Q3 15.7 3 13V8Q3 4 7 4Z'),
    path('M7.5 14L8.2 11.4L12.6 7Q13.3 6.3 14 7L15 8Q15.7 8.7 15 9.4L10.6 13.8Z'),
    path('M11.5 8.1L13.9 10.5'),
  ],
  account,
  check: [confirmation],
  checkCircle: [badge, path(check, { part: 'mark' })],
  close: [path('M6 6L18 18M18 6L6 18')],
  closeCircle: [badge, path(cross, { part: 'mark' })],
  back: [path('M15.2 5.5L9.2 11.2Q8.4 12 9.2 12.8L15.2 18.5')],
  up: [path('M5.5 15.2L11.2 9.2Q12 8.4 12.8 9.2L18.5 15.2')],
  down: [path('M5.5 8.8L11.2 14.8Q12 15.6 12.8 14.8L18.5 8.8')],
  undo: [path('M8.5 4.5L3.8 9.2Q3 10 3.8 10.8L8.5 15.5'), path('M3.7 10H14.5C22.8 10 22.8 20.5 14.5 20.5H8')],
  search: [circle(10.3, 10.3, 7.3), path('M15.6 15.6L21 21')],
  edit: [
    path('M10 4H7Q3 4 3 8V17Q3 21 7 21H16Q20 21 20 17V14'),
    path('M15.8 4.2Q18 2 20 4Q22 6 19.8 8.2L12 16L7.5 17L8.5 12.5Z'),
    path('M14.5 5.5L18.5 9.5'),
  ],
  photo: [rect(3, 3, 18, 18, 4), circle(8.4, 8.4, 1.4), path('M3.5 17L7.3 13.2Q8 12.5 8.7 13.2L11 15.5L14.3 11.7Q15 11 15.7 11.7L20.5 17')],
  share: [path('M9.5 5H7Q3 5 3 9V17Q3 21 7 21H15Q19 21 19 17V14'), path('M12 12L20.5 3.5M14.5 3.5H19.5Q20.5 3.5 20.5 4.5V9.5')],
  mail: [rect(3, 5, 18, 14, 3), path('M3.8 6.5L10.3 11.5Q12 12.8 13.7 11.5L20.2 6.5')],
  copy: [rect(8, 8, 13, 13, 3), path('M16 5V4.8Q16 3 14.2 3H6Q3 3 3 6V14.2Q3 16 4.8 16H5')],
  settings: [
    path('M10 3Q10 2 11 2H13Q14 2 14 3L14.5 5Q16 5.4 17 6.4L19 5.8Q20 5.5 20.5 6.4L21.5 8.1Q22 9 21.2 9.7L19.7 11Q20 12 19.7 13L21.2 14.3Q22 15 21.5 15.9L20.5 17.6Q20 18.5 19 18.2L17 17.6Q16 18.6 14.5 19L14 21Q14 22 13 22H11Q10 22 10 21L9.5 19Q8 18.6 7 17.6L5 18.2Q4 18.5 3.5 17.6L2.5 15.9Q2 15 2.8 14.3L4.3 13Q4 12 4.3 11L2.8 9.7Q2 9 2.5 8.1L3.5 6.4Q4 5.5 5 5.8L7 6.4Q8 5.4 9.5 5Z'),
    circle(12, 12, 3.2),
  ],
  trash: [path('M4 6H20M6 6L6.7 18Q6.8 21 9.5 21H14.5Q17.2 21 17.3 18L18 6M9 6V4.5Q9 3 10.5 3H13.5Q15 3 15 4.5V6M10 10.5V16.5M14 10.5V16.5')],
  flag: [path('M5 21V4Q8 2 12 4T20 4V14Q16 16 12 14T5 14')],
  alert: [path('M12 4.5V13.5M12 19.2H12.01')],
  alertCircle: [badge, path('M12 7.5V12.5M12 16.5H12.01', { part: 'mark' })],
  location: [path('M12 21.5C9.5 19.5 4.5 14.2 4.5 9.5C4.5 .5 19.5 .5 19.5 9.5C19.5 14.2 14.5 19.5 12 21.5Z'), circle(12, 9.5, 2.7)],
  eye: [path('M2.5 12C6 4 18 4 21.5 12C18 20 6 20 2.5 12Z'), circle(12, 12, 3)],
  logout: [path('M10 3H7Q3 3 3 7V17Q3 21 7 21H10'), path('M16 7L20.5 11.2Q21.3 12 20.5 12.8L16 17M8 12H20.5')],
  more: [circle(6, 12, 1.2, { fill: 'currentColor', stroke: 'none' }), circle(12, 12, 1.2, { fill: 'currentColor', stroke: 'none' }), circle(18, 12, 1.2, { fill: 'currentColor', stroke: 'none' })],
  send: [path('M4 8.5L19 3Q21.5 2 20.6 4.8L15.3 20Q14.6 22 13.5 20L10 13.8L3.8 10.3Q2 9.3 4 8.5ZM10 13.8L16 7.8')],
  home: [path('M3.5 10.5L10.6 4Q12 2.8 13.4 4L20.5 10.5M5 9.2V18Q5 21 8 21H16Q19 21 19 18V9.2M9.2 21V15.5Q9.2 14 10.7 14H13.3Q14.8 14 14.8 15.5V21')],
  login: [path('M14 3H17Q21 3 21 7V17Q21 21 17 21H14'), path('M8 7L12.5 11.2Q13.3 12 12.5 12.8L8 17M3 12H12.5')],
  eyeOff: [path('M3 3L21 21M9.2 6.7Q16.8 4.3 21.5 12Q20.1 15.1 17.4 16.6M14.6 17.6Q6.2 19.3 2.5 12Q3.8 9.4 6 7.7M10 10A2.8 2.8 0 0 0 14 14')],
  ban: [circle(12, 12, 8.5), path('M6 6L18 18')],
  users: [circle(9, 7.5, 3.2), path('M2.7 21V18.8C2.7 15.6 5.1 13.6 9 13.6S15.3 15.6 15.3 18.8V21'), path('M16 4.6C20.8 4.6 20.8 10.9 16 10.9M17.8 14C20.2 14.6 21.3 16.1 21.3 18.8V20.5')],
  opinions: [
    circle(12, 12, 9), circle(8.8, 9, 2.1), circle(15.6, 9.7, 1.7),
    path('M5.6 17.6V16.8C5.6 13.5 12.9 13.5 12.9 16.8V20.7M15.6 14.2C17.6 14.2 18.5 15.5 18.5 17.2'),
  ],
  group: [circle(12, 6.3, 2.7), circle(5.2, 9, 2.1), circle(18.8, 9, 2.1), path('M6.6 21V17.7C6.6 14.8 8.7 13 12 13S17.4 14.8 17.4 17.7V21M2.2 19.6V17.3Q2.2 13.9 5.3 13.7M21.8 19.6V17.3Q21.8 13.9 18.7 13.7')],
  follow: [circle(8.8, 7.2, 3.5), path('M2.8 21V18.8C2.8 15.6 5.1 13.6 8.8 13.6Q10.7 13.6 12 14.2M16.1 14.6V21.6M12.6 18.1H19.6')],
  unfollow: [
    ...account.map(([tag, attrs]) => [tag, { ...attrs, part: 'silhouette' }]),
    path('M3 3L21 21', { part: 'slash' }),
  ],
  followed: [path('M2 12.5L6.5 17L16.5 7M12 15L14 17L23 8')],
  chart: [
    path('M5 20.5H19Q20.5 20.5 20.5 19V9.5Q20.5 8 19 8H15V5.5Q15 4 13.5 4H10.5Q9 4 9 5.5V11.5H5Q3.5 11.5 3.5 13V19Q3.5 20.5 5 20.5Z'),
    path('M9 11.5V20.5M15 8V20.5'),
  ],
  globe: [circle(12, 12, 9), path('M3 12H21M4.8 6.5Q12 9.3 19.2 6.5M4.8 17.5Q12 14.7 19.2 17.5M12 3C6.6 7.8 6.6 16.2 12 21C17.4 16.2 17.4 7.8 12 3Z')],
  translate: [path('M3 6H14M8.5 3V6M12 6Q10.2 13.2 4 16M5.5 9Q7.4 12.7 11.5 14.5M13 21L16.7 11.2Q17 10.5 17.3 11.2L21 21M14.3 17.5H19.7')],
  clean: [
    path('M18.5 3L12.3 11'),
    path('M10.6 9.7L14 12.3L12.6 14.2L9.2 11.6Z'),
    path('M9.2 11.6L3.2 17.2Q2.5 17.9 3.3 18.2L11.4 21.4Q12.4 21.7 12.6 20.8V14.2M9.5 14L6.2 19.3M11 15.2L9 20.4'),
  ],
  menu: [path('M4 6H20M4 12H20M4 18H20')],
  redo: [path('M15.5 4.5L20.2 9.2Q21 10 20.2 10.8L15.5 15.5'), path('M20.3 10H9.5C1.2 10 1.2 20.5 9.5 20.5H16')],
  keyboardHide: [rect(2.5, 3.5, 19, 12, 3), path('M6.5 7.5H6.6M10 7.5H10.1M13.7 7.5H13.8M17.4 7.5H17.5M6.5 11.5H6.6M9.5 11.5H15M17.4 11.5H17.5M8.5 19L11.4 21.2Q12 21.7 12.6 21.2L15.5 19')],
  at: [path('M16 9V13.5Q16 16.5 18.5 15.7C22 14.6 22.5 9.3 19.5 5.8C16 1.4 8.8 1.6 5.1 5.5C1.3 9.5 2 16.2 6.3 19.5Q11.7 23.1 17.3 20.1'), path('M16 12C16 6.8 8 6.8 8 12S16 17.2 16 12Z')],
  save: [confirmation],
  bell: [bellBody, bellDetails],
  bellOn: [bellBody, bellDetails, path('M3.4 6.6Q1.8 8.6 1.8 11M20.6 6.6Q22.2 8.6 22.2 11')],
  bellOff: [
    bellDetails,
    // Interrupted contours keep the diagonal legible without a background mask.
    path('M10.1 4.8C13.4 3.3 17.2 5.2 17.2 10.2V12.9M6.8 9.4V14.3Q6.8 16.2 4.9 17.8H14.9'),
    path('M3 3L21 21'),
  ],
  square: [rect(3, 3, 18, 18, 4)],
  checkSquare: [ ['rect', { x: 3, y: 3, width: 18, height: 18, rx: 4, part: 'badge' }], path(check, { part: 'mark' }) ],
};
